const getDate = (order) => {
  var _a;
  return new Date((_a = order == null ? void 0 : order.order_date) == null ? void 0 : _a.replace(/ /g, "T")).toLocaleDateString();
};
const getBaseGrandTotal = (order) => {
  var _a, _b, _c;
  return (_c = (_b = (_a = order == null ? void 0 : order.total) == null ? void 0 : _a.base_grand_total) == null ? void 0 : _b.value) != null ? _c : 0;
};
const getGrandTotal = (order) => {
  var _a, _b;
  return (_b = (_a = order == null ? void 0 : order.total) == null ? void 0 : _a.grand_total.value) != null ? _b : 0;
};
const getOrderCurrency = (order) => {
  var _a, _b;
  return (_b = (_a = order == null ? void 0 : order.total) == null ? void 0 : _a.subtotal.currency) != null ? _b : "USD";
};
const getItemPrice = (item) => {
  var _a, _b;
  return (_b = (_a = item == null ? void 0 : item.product_sale_price) == null ? void 0 : _a.value) != null ? _b : 0;
};
const getPagination = (orders) => {
  var _a, _b, _c;
  return {
    currentPage: ((_a = orders == null ? void 0 : orders.page_info) == null ? void 0 : _a.current_page) || 1,
    totalPages: ((_b = orders == null ? void 0 : orders.page_info) == null ? void 0 : _b.total_pages) || 1,
    totalItems: (orders == null ? void 0 : orders.total_count) || 0,
    itemsPerPage: ((_c = orders == null ? void 0 : orders.page_info) == null ? void 0 : _c.page_size) || 10,
    pageOptions: [10, 50, 100]
  };
};
const orderGetters = {
  getDate,
  getBaseGrandTotal,
  getGrandTotal,
  getOrderCurrency,
  getItemPrice,
  getPagination
};
var orderGetters_default = orderGetters;
export {
  orderGetters_default as default,
  getBaseGrandTotal,
  getDate,
  getGrandTotal,
  getItemPrice,
  getOrderCurrency
};
